import * as React from "react";
import { selectResourceAmountInfo } from "../../../balancingSelectors/selectBalancingResources";
import { IdFortuneTellerEvent } from "../../../constants/IdFortuneTellerEvent";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ButtonWithProgress } from "../../button-with-progress/ButtonWithProgress";
import { IdButtonWithProgressFill } from "../../button-with-progress/IdButtonWithProgressFill";
import { ButtonDefault } from "../../generic/button-buy/ButtonDefault";
import { ButtonSecondary } from "../../generic/common/ButtonSecondary";
import { getResourceIcon } from "../../generic/icon/getResourceIcon";
import { Icon } from "../../generic/icon/Icon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
export var ButtonDivination = function (_a) {
    var onBuyFortuneTellerPackage = _a.onBuyFortuneTellerPackage, fortuneTellerEventPackageDetails = _a.fortuneTellerEventPackageDetails, fortuneTellerBuyPackageTimeStamp = _a.fortuneTellerBuyPackageTimeStamp;
    if (fortuneTellerEventPackageDetails == undefined) {
        return (React.createElement(ButtonSecondary, { disabled: true },
            React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.divination })));
    }
    var isPackagePurchaseInProgress = fortuneTellerBuyPackageTimeStamp !== 0;
    var cost = fortuneTellerEventPackageDetails.cost;
    var costResource = selectResourceAmountInfo(cost.resourceId, cost.amount);
    var costResourceIcon = getResourceIcon(costResource);
    if (!isPackagePurchaseInProgress) {
        return (React.createElement(ButtonDefault, { component: ButtonSecondary, icon: costResourceIcon, locaId: IdLoca.divination, amount: costResource.amount, onClick: function () {
                return onBuyFortuneTellerPackage(fortuneTellerEventPackageDetails.currentPackageId);
            } }));
    }
    return (React.createElement(ButtonWithProgress, { component: ButtonSecondary, remainingTime: fortuneTellerBuyPackageTimeStamp, duration: IdFortuneTellerEvent.BuyPackageCoolDownTime, disabled: true, fillClass: IdButtonWithProgressFill.PrimaryAccent },
        React.createElement("div", { className: "flex flex--stacked flex--aligned" },
            React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.divination }),
            React.createElement("div", { className: "mt--small flex flex--aligned" },
                React.createElement(Icon, { icon: costResourceIcon, styleId: IdStyles.IconMedium }),
                React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondary, amount: costResource.amount })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/components/ButtonDivination.tsx
// module id = 2837
// module chunks = 3